import { useAutoLoadCompanies } from '@pn/core/loaders/company/getCompanies';
import { useAutoLoadSelectedCompany } from '@pn/core/loaders/intel/getCompanyExtraInfo';
import { useAutoInitializeFreshDesk } from '@pn/services/support/useAutoInitializeFreshDesk';
import { useAutoGetIntelWorkspaceItems } from 'src/application/loaders/getIntelWorkspaceItems';
import { useAutoLoadIntelData } from 'src/application/loaders/intel-data/getIntelData';
import { useLoadReportData } from 'src/application/loaders/report/getReportData';
import { useAutoLoadIntelReports } from 'src/application/loaders/report/getReports';
import { useAutoDeleteWorkspaceItems } from 'src/ui/hooks/useAutoDeleteWorkspaceItems';
import { useAutoRemoveWorkspaceItems } from 'src/ui/hooks/useAutoRemoveWorkspaceItems';

export function Effects() {
  useAutoLoadSelectedCompany();
  useAutoLoadIntelData();

  useAutoLoadCompanies();

  useAutoGetIntelWorkspaceItems();

  useAutoInitializeFreshDesk('intel');

  useAutoRemoveWorkspaceItems();
  useAutoDeleteWorkspaceItems();
  useLoadReportData();
  useAutoLoadIntelReports();

  return null;
}
